export default "__VITE_ASSET__fW5FAIJQ__"